module.exports = __webpack_public_path__ + "img/dsci0059.c7780675.jpg";